import React, { useState } from 'react';
import PopupNew from '../Components/Popup/Popupnew';
import PopupConfirmation from '../Components/Popup/PopupConfirmation';

function Test() {
  const [showPopup, setShowPopup] = useState(true);
  const [showPopuptwo, setShowPopuptwo] = useState(true);

  const handleCancel = () => {
    console.log("Cancelled");
    setShowPopup(false);
  };

  const handleSubmit = () => {
    console.log("Submitted");
    setShowPopup(false);
  };
  return (
    <div>
      {/* <PopupNew
        show={showPopup}
        onClose={() => setShowPopup(false)}
        errorMessage="Permanently Submited SAL-ORD-2025-00591"
        poptype="Error"
      /> */}

      <PopupConfirmation
        show={showPopuptwo}
        onClose={() => setShowPopuptwo(false)}
        Message="Are you sure you want to submit all the selected data? After submission you won’t be able to edit the list"
        msgtype="Confirm Submission"
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </div>
  )
}

export default Test
